import { SETGROUP } from "./actionTypes";

export const setGroup = (data) => {
    return {
      type: SETGROUP,
      payload: data,
    };
  };